var _circle, _path, _rect, _rect2, _rect3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGlobalSelectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 8.9,
    stroke: "#505768",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7 12.5C17.7 15.0802 17.0939 17.4014 16.1295 19.0672C15.1605 20.7408 13.8666 21.7 12.5 21.7C11.1334 21.7 9.83947 20.7408 8.87054 19.0672C7.90611 17.4014 7.3 15.0802 7.3 12.5C7.3 9.91983 7.90611 7.59863 8.87054 5.9328C9.83947 4.25919 11.1334 3.3 12.5 3.3C13.8666 3.3 15.1605 4.25919 16.1295 5.9328C17.0939 7.59863 17.7 9.91983 17.7 12.5Z",
    stroke: "#505768",
    strokeWidth: 0.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.2,
    y: 4,
    width: 0.6,
    height: 17,
    fill: "#505768"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9,
    width: 17,
    height: 0.6,
    fill: "#505768"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 15.4,
    width: 17,
    height: 0.6,
    fill: "#505768"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalSelectIcon);
export default __webpack_public_path__ + "static/media/global_select_icon.dcaffd6587bf23402893624e7d3a16cc.svg";
export { ForwardRef as ReactComponent };